import * as React from "react"
import { AlertCircle } from "lucide-react"

import { cn } from "@/lib/utils"

interface FormErrorProps {
  id?: string
  message?: string | null | false
  className?: string
}

/**
 * Inline validation error message for a form field; announced to screen readers via role="alert".
 *
 * @category Forms
 */
export function FormError({ id, message, className }: FormErrorProps) {
  if (!message) return null
  return (
    <p
      id={id}
      role="alert"
      className={cn(
        "mt-1 flex items-start gap-1 text-sm text-destructive",
        className
      )}
    >
      <AlertCircle className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span>{message}</span>
    </p>
  )
}

interface FormHintProps {
  children: React.ReactNode
  className?: string
}

/**
 * Muted helper text rendered under a form field.
 *
 * @category Forms
 */
export function FormHint({ children, className }: FormHintProps) {
  return (
    <p className={cn("mt-1 text-xs text-muted-foreground", className)}>
      {children}
    </p>
  )
}
